<template >
  <b-card title="Bar">
    <b-card img-bottom >
      <ChartBarBase :chart-data="chartData" />
    </b-card>
  </b-card>
</template>

<style>

</style>

<script>
import ChartBarBase from "./ChartBarBase1.js";

export default {
  components: {
    ChartBarBase
  },
  data() {
    return {
      chartData: null
    };
  },
  props: {
    subjects: {
      type: Array,
      required: true,
    },
    subName: {
      type:Array,
      required: true
    }
  },
  mounted() {
    
    console.log("hg",this.subjects);
    this.fillData();
  },
  methods: {
    
    fillData() {
       console.log("hg1",this.subjects);
      this.chartData = {
       //labels: ["Programming & Data Structure", "Networking & Cyber Security", "Data Science", "Analitycal Ability", "English Comprehension"],
        labels: this.subName,
        datasets: [
          
          {
            type:"bar",
            backgroundColor: "#98ddde",
            borderColor: "#030c0c",
            data: this.subjects,
            // label: "This year"
          }
        ]
      };
    }
  }
};
</script>